import React from '../../../../_snowpack/pkg/react.js'; // @ts-ignore

import styled from '../../../../_snowpack/pkg/styled-components.js'; // @ts-ignore

import { Button } from '../../../css/buttons.js';
import { useTenant } from '../../../hooks/index.js';
import { Link } from '../../../../_snowpack/pkg/react-router-dom.js';
import { ATOM_PLAN, CRYSTAL_PLAN, PARTICLE_PLAN, YOUR_CURRENT_PLAN } from './create-crystallize-subscription/constants.js';
import { SubscriptionChange } from './create-crystallize-subscription/interfaces.js';
const CurrentPlanButton = styled(Button).withConfig({
  displayName: "plan-action-button__CurrentPlanButton",
  componentId: "nucems-0"
})(["background:transparent;border:1px solid ", " !important;border-radius:8px;width:100%;span{color:", ";background-color:transparent !important;box-shadow:none !important;}"], ({
  theme
}) => theme.colors.label, ({
  theme
}) => theme.colors.label);
export const ChoosePlan = ({
  planName,
  disabled,
  buttonLabel,
  linkUrl,
  activeProdSubId,
  onChangePlanOnly,
  subscriptionOp
}) => {
  const {
    tenant
  } = useTenant();
  const upgradeWithoutPayment = subscriptionOp === SubscriptionChange.UpgradeParticleToAtomWithoutPayment;
  const downgradeWithoutPayment = subscriptionOp === SubscriptionChange.DowngradeAtomToParticleWithoutPayment;

  const getRouteState = () => {
    if (subscriptionOp === SubscriptionChange.UpgradeParticleToAtomWithPayment || subscriptionOp === SubscriptionChange.DowngradeAtomToParticleWithPayment || subscriptionOp === SubscriptionChange.AddPaymentToCurrentSubscription) {
      return {
        planName: planName === PARTICLE_PLAN ? PARTICLE_PLAN : planName === ATOM_PLAN ? ATOM_PLAN : CRYSTAL_PLAN,
        activeProdSubId,
        subscriptionOp
      };
    } else {
      return {
        planName: planName === PARTICLE_PLAN ? PARTICLE_PLAN : planName === ATOM_PLAN ? ATOM_PLAN : CRYSTAL_PLAN
      };
    }
  };

  if ((planName === PARTICLE_PLAN || planName === ATOM_PLAN) && buttonLabel === YOUR_CURRENT_PLAN && !linkUrl) return /*#__PURE__*/React.createElement(CurrentPlanButton, {
    regularparticle: 'true',
    medium: true,
    disabled: disabled
  }, buttonLabel);
  if (planName === PARTICLE_PLAN && downgradeWithoutPayment) return /*#__PURE__*/React.createElement(Button, {
    regularparticle: 'true',
    medium: true,
    onClick: () => onChangePlanOnly(PARTICLE_PLAN, subscriptionOp),
    disabled: disabled
  }, buttonLabel);
  if (planName === ATOM_PLAN && upgradeWithoutPayment) return /*#__PURE__*/React.createElement(Button, {
    regularatom: 'true',
    medium: true,
    onClick: () => onChangePlanOnly(ATOM_PLAN, subscriptionOp),
    disabled: disabled
  }, buttonLabel);
  return /*#__PURE__*/React.createElement(React.Fragment, null, planName === PARTICLE_PLAN && /*#__PURE__*/React.createElement(Button, {
    regularparticle: 'true',
    medium: true,
    disabled: disabled,
    as: Link,
    to: {
      pathname: `${linkUrl}`,
      state: getRouteState()
    }
  }, buttonLabel), planName === ATOM_PLAN && /*#__PURE__*/React.createElement(Button, {
    regularatom: 'true',
    medium: true,
    as: Link,
    to: {
      pathname: `${linkUrl}`,
      state: getRouteState()
    },
    disabled: disabled
  }, buttonLabel), planName === CRYSTAL_PLAN && /*#__PURE__*/React.createElement(Button, {
    regularcrystal: 'true',
    medium: true,
    as: Link,
    to: `/settings/tenants/${tenant.identifier}/plans/crystal`,
    disabled: disabled
  }, buttonLabel));
};